<template>
  <div id="page">
    <sub-menu id="section-submenu" nohide="true"></sub-menu>
    <div v-if="currentPage" class="block-wrapper">
      <div class="content sans lazy-container">
        <div
          v-for="(block, index) in currentPage.acf.description"
          class="block-wrapper"
          :key="index"
        >
          <h3 class="block-heading mb2" v-if="block.block_heading">
            {{ block.block_heading }}
          </h3>
          <div v-if="block.block_content.columns === '1'" class="block-content">
            <div v-html="block.block_content.column_1"></div>
          </div>
          <div v-else class="block-content flex two-col">
            <div
              v-html="block.block_content.column_1"
              class="block-column col-6"
            ></div>
            <div
              v-html="block.block_content.column_2"
              class="block-column col-6"
            ></div>
          </div>
        </div>

        <person-list
          v-if="this.$route.params.page === 'advisory-board'"
          :content="currentPage.acf.people"
        ></person-list>

        <org-list
          v-if="this.$route.params.page === 'funding'"
          title="Funding Organisations ↘"
          :content="currentPage.acf.funders"
        ></org-list>

        <org-list
          v-if="this.$route.params.page === 'funding'"
          title="Donors ↘"
          :content="currentPage.acf.donors"
        ></org-list>

        <org-list
          v-if="this.$route.params.page === 'funding'"
          title="Collections ↘"
          :content="currentPage.acf.collections"
        ></org-list>
      </div>

      <recognition-table
        id="recognition"
        class="max-width-reader"
        v-if="showRecognition"
        :showTitle="false"
        :content="recognition"
      ></recognition-table>

      <press-table
        id="press"
        class="max-width-reader"
        v-if="showPress"
        :showTitle="false"
        :content="fapress"
      ></press-table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SubMenu from "@/components/SubMenu";
import RecognitionTable from "@/components/RecognitionTable";
import PressTable from "@/components/PressTable";
import OrgList from "@/components/OrgList";
import PersonList from "@/components/PersonList";

export default {
  name: "Page",

  data() {
    return {
      lazyContainer: this.lazyLoad({
        elements_selector: ".lazy-container img",
      }),
    };
  },

  metaInfo() {
    let title = this.currentPage.title.rendered.replace("&#038;", "&");
    return {
      title: title || "Loading...",
      meta: [
        { name: "og:title", content: `Forensic Architecture → ${title}` },
        { name: "twitter:title", content: `Forensic Architecture → ${title}` },
        { name: "og:image", content: "/fa-share-lg.png" },
        { name: "twitter:image", content: "/fa-share-lg.png" },
        {
          name: "og:url",
          content: `${window.location.origin}/${this.$route.fullPath}`,
        },
        { name: "og:type", content: "website" },
        { name: "og:description", content: this.siteDescription() },
        { name: "twitter:description", content: this.siteDescription() },
      ],
    };
  },

  components: {
    RecognitionTable,
    PressTable,
    PersonList,
    OrgList,
    SubMenu,
  },

  mounted: function () {
    this.updatePage();
  },

  computed: {
    ...mapState(["recognition", "pages", "fapress"]),
    currentPage() {
      let slug = this.$route.params.page;
      if (this.pages.hasOwnProperty(slug)) {
        return this.pages[slug];
      } else {
        return false;
      }
    },
    showRecognition() {
      return this.recognition && this.$route.params.page === "recognition";
    },
    showPress() {
      return this.fapress && this.$route.params.page === "press";
    },
  },

  methods: {
    ...mapActions(["getPage", "getfapress"]),
    updatePage() {
      this.$nextTick(function () {
        this.lazyContainer.update();
      });
      if (this.$route.params.page === "press") {
        this.getfapress();
      }
    },
  },

  beforeRouteUpdate(to, from, next) {
    this.getPage(to.params.page).then(function () {
      next();
    });
  },

  watch: {
    $route() {
      this.updatePage();
    },
  },
};
</script>

<style lang="css" scoped>
.block-wrapper:last-child {
  margin-bottom: 0;
}
#page {
  .block-wrapper {
    margin-bottom: 6em;
  }
}
div.content + section#press {
  margin-top: -4em;
}
</style>
